var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 48,
    viewBox: "0 0 193 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_438_2238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1576 0C13.5768 0 9.33025 3.44225 5.83015 9.22302C2.17874 15.2155 0 22.6291 0 29.0701C0 38.4998 5.29555 48.005 17.1576 48.005C29.0196 48.005 34.3151 38.4998 34.3151 29.0701C34.3151 22.6291 32.1364 15.2155 28.5052 9.22806C24.9698 3.44225 20.7283 0 17.1576 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.794 14.1419H121.802V45.4296H134.668V14.1419H146.676V2.57031H109.794V14.1419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.128 14.1419H193V2.57031H174.128C156.789 2.57031 147.529 11.1835 147.529 24C147.529 36.8164 156.784 45.4296 174.128 45.4296H193V33.858H174.128C166.104 33.858 160.829 30.9903 160.829 24C160.829 17.0096 166.104 14.1419 174.128 14.1419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6243 2.57031L76.7653 28.1528L69.9063 2.57031H47.1758V45.4296H60.0414V10.5686L69.3919 45.4296H84.1437L93.4992 10.5485V45.4296H106.365V2.57031H83.6243Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_438_2238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 193,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo02);
export default __webpack_public_path__ + "static/media/logo02.8658fcb1cd123438e7b390d0c2a6be25.svg";
export { ForwardRef as ReactComponent };